import * as React from "react";
import UserService from '../../services/userService';
import Spinner from '../../common/components/spinner/spinner';
import Translate from "../../common/functions/translate";
import Snackbar from "../../common/components/snackbar/snackbar";
import { UserModel } from "../../models/user";
import AuthService from "../../services/authService";
import { Role } from "../../common/enums";
import Link from '@material-ui/core/Link';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import ChangePasswordDialog from './changePasswordDialog';
import EditUserInfoDialog from './editUserInfoDialog';
import Paper from '@material-ui/core/Paper';
import EditIcon from '@material-ui/icons/Edit';

interface IProps {
}

interface IState {
    isLoading: boolean;
    user: UserModel;
    validationMessage: string;
    isVisibleChangePasswordDialog: boolean;
    isVisibleChangePasswordDialogWrap: boolean;
    isVisibleEditUserInfoDialog: boolean;
    isVisibleEditUserInfoDialogWrap: boolean;
}

class UserProfile extends React.Component<IProps, IState> {
    snackbar: any;
    authService = new AuthService();
    userService = new UserService();
    messages: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            user: new UserModel(),
            validationMessage: '',
            isVisibleChangePasswordDialog: false,
            isVisibleChangePasswordDialogWrap: false,
            isVisibleEditUserInfoDialog: false,
            isVisibleEditUserInfoDialogWrap: false
        };
    }

    // events
    componentDidMount() {
        this.getUserData();
    }

    getUserData = () => {
        this.setState({ isLoading: true });

        this.userService.getUser(this.authService.getUserId()).then(
            (user: any) => {
                this.setState({
                    isLoading: false,
                    user
                });
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                })
            })
    }

    showChangePasswordDialog = (show: boolean) => {
        this.setState({
            isVisibleChangePasswordDialogWrap: show,
            validationMessage: ''
        });
        setTimeout(() => this.setState({
            isVisibleChangePasswordDialog: show
        }));
    };

    showEditUserInfoDialog = (show: boolean) => {
        this.setState({
            isVisibleEditUserInfoDialogWrap: show,
            validationMessage: ''
        });
        setTimeout(() => this.setState({
            isVisibleEditUserInfoDialog: show
        }));
    }

    handleSuccessPasswordChange = () => {
        this.showChangePasswordDialog(false);
        this.snackbar.show({ severity: 'success', summary: Translate('Password successfully changed') });
    }

    handleSuccessEditUserInfo = () => {
        this.showEditUserInfoDialog(false);
        this.snackbar.show({ severity: 'success', summary: Translate('Profile data succesfully saved') });
        this.getUserData();
    }

    handleCancelButton = () => {
        this.showChangePasswordDialog(false);
        this.showEditUserInfoDialog(false);
    };

    // render
    public render() {
        const { isLoading, user, validationMessage } = this.state;

        return (
            <div>

                <h3>{Translate("Profile")}</h3>

                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />

                {this.state.validationMessage ? <AlertMessage type='danger'>{validationMessage}</AlertMessage> : null}

                <Paper elevation={3} className="profile-card" >
                    <div style={{ padding: 20 }}>
                        <div className="profile-card-item">
                            <div>
                                {Translate('Email')}:
                            </div>
                            <div>
                                <strong>{user.email}</strong>
                            </div>
                        </div>
                        <div className="profile-card-item">
                            <div>
                                {Translate('Role')}:
                            </div>
                            <div>
                                <strong>
                                    {user.roleId === Role.Administrator ? Translate('Administrator') : ''}
                                    {user.roleId === Role.ProductManager ? Translate('ProductManager') : ''}
                                    {user.roleId === Role.RegionalManager ? Translate('RegionalManager') : ''}
                                    {user.roleId === Role.Trader ? Translate('Trader') : ''}
                                </strong>
                            </div>
                        </div>
                        <div className="profile-card-item">
                            <div>
                                {Translate('Code')}:
                            </div>
                            <div>
                                <strong>{user.code}</strong>
                            </div>
                        </div>
                        {user.regionId
                            ? <div className="profile-card-item">
                                <div>
                                    {Translate('Region')}:
                                </div>
                                <div>
                                    <strong>{user.region}</strong>
                                </div>
                            </div>
                            : null}
                        <hr className="profile-separator" />
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <div className="profile-card-item">
                                <div>
                                    {Translate('Name')}:
                                </div>
                                <div>
                                    <strong>{user.name}</strong>
                                </div>
                            </div>
                            <div>
                                <EditIcon
                                    className="profile-edit-info"
                                    onClick={() => this.showEditUserInfoDialog(true)} />
                            </div>
                        </div>

                        {user.phone
                            ? <div className="profile-card-item">
                                <div>
                                    {Translate('Phone')}:
                                </div>
                                <div>
                                    <strong>{user.phone}</strong>
                                </div>
                            </div>
                            : null}
                        <hr className="profile-separator" />
                        <div style={{ marginTop: 10 }}>
                            <Link href="#" onClick={() => this.showChangePasswordDialog(true)}>
                                {Translate('Change password')}
                            </Link>
                        </div>

                    </div>
                </Paper>
                {
                    this.state.isVisibleChangePasswordDialogWrap ? (
                        <ChangePasswordDialog
                            onSuccessPasswordChange={this.handleSuccessPasswordChange}
                            cancelClick={this.handleCancelButton}
                            isVisible={this.state.isVisibleChangePasswordDialog}
                        />
                    ) : null
                }
                {
                    this.state.isVisibleEditUserInfoDialogWrap ? (
                        <EditUserInfoDialog
                            onSuccessEdit={this.handleSuccessEditUserInfo}
                            cancelClick={this.handleCancelButton}
                            currentUser={user}
                            isVisible={this.state.isVisibleEditUserInfoDialog}
                        />
                    ) : null
                }

            </div >
        );
    }
}

export default UserProfile;
